module.exports = __webpack_public_path__ + "src/assets/games/34/TUBES069.jpg";